import { TooltipOption } from "echarts/types/dist/shared";
import { EvaChartStates } from "types/factory";

import { formatTotalRateDateChartTooltip } from "./utils";

// Overrides the per-unit default (0 for bbl/d up to 6 for MMbbl/d).
const TOTAL_RATE_DATE_TOOLTIP_PRECISION = 3;

export function translateTotalRateDateResponseTooltipOptions(
  states: EvaChartStates
): TooltipOption {
  const { layout, hoverLegendIdRef, series, wellCountsOptions } = states;

  const yAxisTitle = layout?.yAxis?.title || "";

  return {
    trigger: "axis",
    confine: true,
    enterable: true,
    extraCssText: "border-style:none;",
    className: "chart-tooltip-container",
    showDelay: 500,
    hideDelay: 0,
    show: true,
    axisPointer: {
      label: {
        precision: 2,
        show: true
      },
      type: "cross"
    },

    position: function (point, _, dom) {
      const xPos = point[0];
      const yPos =
        point[1] - (dom as HTMLDivElement).offsetHeight > 48
          ? point[1] - (dom as HTMLDivElement).offsetHeight
          : 48;
      return [xPos, yPos]; //position top right of mouse cursor
    },
    formatter: (items) =>
      formatTotalRateDateChartTooltip(
        items,
        hoverLegendIdRef?.current,
        series,
        yAxisTitle,
        false,
        TOTAL_RATE_DATE_TOOLTIP_PRECISION,
        wellCountsOptions,
        layout?.xAxis?.data
      )
  };
}
